import { useIntlContext } from '@awazevr/mfe-common.contexts.intl'

import { outsideDestinationSubtext } from './messages'
import {
  LowResultsHeading,
  LowResultsLink,
  LowResultsMessageContainer,
  LowResultsSubtext,
} from './PropertiesNearby.style'

export interface LowResultsMessageProps {
  destination: string
  /** Hidden on undated searches (no dates/flexibility to change). */
  showChangeDatesLink: boolean
  onChangeDates: () => void
}

export const LowResultsMessage = ({
  destination,
  showChangeDatesLink,
  onChangeDates,
}: LowResultsMessageProps): JSX.Element => {
  const { formatMessage } = useIntlContext()

  return (
    <LowResultsMessageContainer data-testid="low-results-message">
      <LowResultsHeading>
        {formatMessage({
          id: 'search-results.low-results.heading',
          defaultMessage:
            "We don't have any more available properties for your search",
        })}
      </LowResultsHeading>
      <LowResultsSubtext>
        {formatMessage(outsideDestinationSubtext, { destination })}
      </LowResultsSubtext>
      {showChangeDatesLink && (
        <LowResultsLink
          type="button"
          onClick={onChangeDates}
          data-testid="low-results-change-dates"
        >
          {formatMessage({
            id: 'search-results.low-results.change-dates',
            defaultMessage: 'Change your dates or flexibility',
          })}
        </LowResultsLink>
      )}
    </LowResultsMessageContainer>
  )
}
